import cx from 'classnames';
import { useDispatch } from 'react-redux';
import { icons } from '../assets';
import { RestoreIcon } from '../components/icons/RestoreIcon';
import { ARCHIVE_ICON } from '../constants/assetConstants';
import { apiRestoreMutipleArchivedAutomation } from '../helpers/api';
import { successToast } from '../helpers/toastHelper';
import { paginatedAutomationActions } from '../redux/slicers/admin/paginatedAutomation';
import ThumbnailCardUI, { ACTION } from './ThumbnailCardUI';
import styles from './ThumbnailCardUI.module.scss';
import ThumbnailCardV2 from './ThumbnailCardV2';
import { useImagineAIActions } from '../hooks/useImagineAIActions';
import ImagineAIDetails from '../screens/ImagineAIDetails';
import { useState } from 'react';
import { AI_WEBSITE_URL } from '../constants/routePathConstants';
import { getLocalStorage, removeInvertedCommaFromStartEnd, removeUndefinedText } from '../helpers/jsHelper';
import constants from '../constants/constants';
import { useUserContext } from '../contexts/UserContext';
import { ElipsisTooltip } from './ElipsisTooltip';
const { InfoIcon, ArchiveIcon, CopyIcon } = icons;

const OverlayOnCardHover = ({ text = '', onClick = null }) => {
  if (!text || text === 'undefined' || text === 'null') return null;

  const _text = removeInvertedCommaFromStartEnd(text);
  return (
    <div className={cx(styles.overlayContent, 'overlay')}>
      <ElipsisTooltip title="Copy Prompt" alwaysShow={true}>
        {({ ref, onMouseEnter, onMouseLeave }) => (
          <span ref={ref} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onClick}>
            <CopyIcon />
          </span>
        )}
      </ElipsisTooltip>
      <p>{_text}</p>
    </div>
  );
};

const CopyPrompt = ({ onClick }) => (
  <ElipsisTooltip title="Copy Prompt" alwaysShow={true}>
    {({ ref, onMouseEnter, onMouseLeave }) => (
      <span
        ref={ref}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className="cursor-pointer"
        onClick={onClick}>
        <CopyIcon />
      </span>
    )}
  </ElipsisTooltip>
);

export const ThumbnailCardImagineAI = ({
  data,
  size,
  fullWidth,
  onSelect,
  selected,
  hideFavourite,
  onEdit,
  onEditInfo,
  onDelete,
  customActions,
  designV2,
  showMenu,
  ...rest
}) => {
  const { isGuestUser } = useUserContext();
  const {
    onDelete: _onDelete,
    onFavouriteToggle,
    favouriteLoading,
    downloadImagineAI,
    downloadLoading,
    addToCollection,
    copyPrompt,
  } = useImagineAIActions({
    item: data,
  });

  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useDispatch();

  const handleEdit = () => {
    const currentImage = data?.output_image || data?.input_image || data?.manual_output_image_path;
    if (currentImage) {
      const token = getLocalStorage('token');
      const refreshToken = getLocalStorage('refresh_token');
      const url = `${AI_WEBSITE_URL}magic-tool?renderFile=${encodeURIComponent(
        currentImage
      )}&token=${encodeURIComponent(token)}&refresh_token=${encodeURIComponent(refreshToken)}`;
      window.open(url, '_blank');
    }
  };

  const handleReUse = (id) => {
    if (id) {
      const token = getLocalStorage('token');
      const refreshToken = getLocalStorage('refresh_token');
      const url = `${AI_WEBSITE_URL}image-gen?ai_id=${id}&token=${encodeURIComponent(
        token
      )}&refresh_token=${encodeURIComponent(refreshToken)}`;
      window.open(url, '_blank');
    }
  };

  const handleDelete = onDelete || _onDelete;
  const count = data?.template_count || 0;
  const isArchived = data?.is_archive;
  const isOldObj = data?.is_old_obj;
  let actions = {
    [ACTION.COPY]: {
      label: 'Copy Prompt',
      icon: designV2 ? CopyIcon : <CopyIcon />,
      onClick:
        !data?.name || data?.name === 'undefined' || data?.name === 'null'
          ? null
          : (e) => copyPrompt(e),
    },
  };

  const onRestore = async (id) => {
    var formData = new FormData();
    formData.append('id', id);

    const res = await apiRestoreMutipleArchivedAutomation(formData);

    if (res.status) {
      dispatch(paginatedAutomationActions.deleteStart({ itemId: id }));
      !res?.message && successToast('Automation restored successfully.');
      dispatch(paginatedAutomationActions.deleteSuccess({ itemId: id }));
    } else dispatch(paginatedAutomationActions.deleteFailed({ itemId: id }));
  };

  if (isArchived) {
    actions = {
      [ACTION.RESTORE]: {
        label: 'Restore',
        icon: designV2 ? RestoreIcon : <RestoreIcon />,
        onClick: onRestore,
      },
      [ACTION.RETRY]: { onClick: null },
      [ACTION.RAISE_TICKET]: { onClick: null },
      [ACTION.DOWNLOAD]: { onClick: null },
      [ACTION.EDIT]: { onClick: null },
      [ACTION.SHARE]: { onClick: null },
      [ACTION.ADD_TO_COLLECTION]: { onClick: null },
      [ACTION.DELETE]: { onClick: null },
      [ACTION.EDIT_INFO]: { onClick: null },
    };
    hideFavourite = true;
  }

  if (!actions) {
    actions = data.is_main_render
      ? {
          [ACTION.DELETE]: {
            label: 'Archive',
            icon: designV2 ? ArchiveIcon : <img src={ARCHIVE_ICON} alt="Archive" />,
          },
        }
      : undefined;
  }

  const onClick = () => {
    setIsOpen(true);
  };

  const name = removeUndefinedText(data?.text_prompt) || data?.name

  return (
    <>
      {designV2 ? (
        <ThumbnailCardV2
          onFavouriteChange={onFavouriteToggle(data)}
          onSelect={onSelect}
          selected={selected}
          isFavourite={data.is_favourite}
          hideFavourite={hideFavourite}
          favouriteLoading={favouriteLoading}
          // titleProps={titleProps}
          onCardClick={onClick}
          data={data}
          name={name}
          iconSideToTitle={<CopyPrompt onClick={copyPrompt} />}
          thumbnail={data?.thumbnail || data?.thumbnail_output_image || data?.manual_thumb_output_image_path || data?.thumb}
          date={data?.updated_at || data.created_at}
          userCard
          showMenu={showMenu && !isGuestUser()}
          id={data?.id}
          redirect={false}
          target=""
          customActions={actions}
          showCheckbox
          isFavouriteIcon
          onEditAI={handleEdit}
          // onReUse={!data?.upscaled && data?.tool_type !== 'magic_tool' ? handleReUse : null} // hiding re-imagine tool
          onDelete={isOldObj ? null : handleDelete}
          onDownload={() =>
            downloadImagineAI({ id: data?.id, name: data?.name, url: data?.output_image || data?.input_image || data?.manual_output_image_path })
          }
          downloadLoading={downloadLoading}
          fullWidth={fullWidth}
          // overlayOnCardHover={<OverlayOnCardHover text={data?.name} onClick={copyPrompt} />}
          {...rest}
        />
      ) : (
        <ThumbnailCardUI
          key={data.id}
          id={data.id}
          target=""
          thumbnail={data?.thumbnail || data?.thumbnail_output_image || data?.manual_thumb_output_image_path || data?.thumb}
          name={name}
          isFavourite={data.is_favourite}
          favouriteLoading={favouriteLoading}
          date={data.created_at}
          onDelete={isOldObj ? null : handleDelete}
          onFavouriteChange={onFavouriteToggle(data)}
          size={size}
          onDownload={() =>
            downloadImagineAI({ id: data?.id, name: data?.name, url: data?.output_image || data?.input_image || data?.manual_output_image_path })
          }
          downloadLoading={downloadLoading}
          fullWidth={fullWidth}
          onSelect={onSelect}
          selected={selected}
          onEditAI={handleEdit}
          // onReUse={!data?.upscaled && data?.tool_type !== 'magic_tool' ? handleReUse : null} // hiding re-imagine tool
          hideFavourite={hideFavourite}
          data={data}
          customActions={actions}
          actionsListClassName={
            isArchived ? styles.actionListSpaceAround : styles.actionListSpaceBetween
          }
          showActionsText={isArchived}
          {...rest}
        />
      )}
      {isOpen ? (
        <ImagineAIDetails
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          data={data}
          hasMore={rest?.hasMore}
          fetchMoreData={rest?.fetchMoreData}
          list={rest?.list}
          loading={rest?.loading}
        />
      ) : null}
    </>
  );
};
